import React, {PropsWithChildren} from 'react';
import {observer} from "mobx-react";
import {VideoSlideLayoutBox} from './boxes/video-slide-layout.box';

export const VideoSlideLayoutComponent: React.FC<PropsWithChildren> = observer((props) => {
    return (
        <VideoSlideLayoutBox>
            {props.children}
        </VideoSlideLayoutBox>
    )
})